module.exports = __webpack_public_path__ + "media/images/credits_logo_large-d2c2766e91f273cb9556ab1c72ebeed9bab97bdf2fc2bcb27f8362a7282d0b58.png";